export interface IAmplitudeLogger {
    warn: (message: string, ...args: unknown[]) => void;
    error: (message: string, ...args: unknown[]) => void;
}

export const defaultAmplitudeLogger: IAmplitudeLogger = {
    warn: (message, ...args) => console.warn(message, ...args),
    error: (message, ...args) => console.error(message, ...args)
};
export interface IAmplitudeLogger {
    warn: (message: string, ...args: unknown[]) => void;
    error: (message: string, ...args: unknown[]) => void;
}

export const defaultAmplitudeLogger: IAmplitudeLogger = {
    warn: (message, ...args) => console.warn(message, ...args),
    error: (message, ...args) => console.error(message, ...args)
};
